import { render } from "./modal-right-full-page-notification.html?vue&type=template&id=79a9d277&scoped=true&ts=true"
import script from "./modal-right-full-page-notification.vue?vue&type=script&lang=ts"
export * from "./modal-right-full-page-notification.vue?vue&type=script&lang=ts"

import "./modal-right-full-page-notification.scss?vue&type=style&index=0&id=79a9d277&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a9d277"]])

export default __exports__